import baseApi, {
    transformResponseFromData,
    provideTags,
} from 'store/slices/api/baseApi'

// only the organizations the logged in user belongs to
const organizationsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getMyOrganizations: build.query({
            query: () => ({url: 'organizations/my', method: 'GET'}),
            transformResponse: transformResponseFromData,
            providesTags: (result) => provideTags('Organization', result),
        }),
        createMyOrganization: build.mutation({
            query: (organization) => ({
                url: 'organizations/my',
                method: 'POST',
                body: organization,
            }),
            invalidatesTags: [{type: 'Organization', id: 'LIST'}],
        }),
        updateMyOrganization: build.mutation({
            query: ({_id, ...organization}) => ({
                url: `organizations/my/${_id}`,
                method: 'PUT',
                body: organization,
            }),
            invalidatesTags: [{type: 'Organization', id: 'LIST'}],
        }),
        addMyOrganizationMember: build.mutation({
            query: ({organizationId, ...member}) => ({
                url: `organizations/my/${organizationId}/users`,
                method: 'POST',
                body: member,
            }),
            invalidatesTags: [{type: 'Organization', id: 'LIST'}],
        }),
        removeMyOrganizationMember: build.mutation({
            query: ({organizationId, memberId}) => ({
                url: `organizations/my/${organizationId}/users/${memberId}`,
                method: 'DELETE',
            }),
            invalidatesTags: [{type: 'Organization', id: 'LIST'}],
        }),
    }),
})

export default organizationsApi

export const {
    useGetMyOrganizationsQuery,
    useCreateMyOrganizationMutation,
    useUpdateMyOrganizationMutation,
    useAddMyOrganizationMemberMutation,
    useRemoveMyOrganizationMemberMutation,
} = organizationsApi
